import script from "./DeleteHighlightPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeleteHighlightPopup.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__